<script setup lang="ts">
const emit = defineEmits(["submit"]);
</script>

<template>
  <form class="form-element" @submit.prevent="emit('submit')">
    <slot />
  </form>
</template>

<style lang="scss" scoped>
.form-element {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
}
</style>
